module.exports = __webpack_public_path__ + "static/media/brand-group.a0b6ef3c.png";